import React from "react";
import { connect } from "react-redux";
import { PageTabs } from "../../../../../../../store/AppDisplays";
import { GeneralLedgers } from "../../../../../../../store/GeneralLedgers/Types";
import { ReduxState, isRemoteLoading } from "../../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../../store/RemoteTypes";
import { Filter } from "../../../../02-pages/Filter";
import { Results } from "../../../../02-pages/Results";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";

interface OwnProps {
    statementLineId: string;
}

interface State {
}

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: GeneralLedgers;
}

type Props = OwnProps & StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.GENERAL_LEDGER),
    results:
            s.prop("remote").prop(RemoteScope.GENERAL_LEDGER),
});

/**
 *
 * @param props
 */
export class GeneralLedgerComp
    extends React.Component<Props, State> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);

        this.state = {};
    }

    public render() {
        return (
            <Div style={{marginTop: "-20px"}}>
                <Filter
                    loadingFilters={this.props.loadingFilters}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.ACCOUNTS_DETAIL_STATEMENTS_DETAIL_BOOK_GENERAL_LEDGER}
                />
                <Results
                    results={this.props.results}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.ACCOUNTS_DETAIL_STATEMENTS_DETAIL_BOOK_GENERAL_LEDGER}
                    statementLineId={this.props.statementLineId}
                    scope={RemoteScope.GENERAL_LEDGER}
                />
            </Div>
        );
    }
}

/**
 *
 */
export const GeneralLedger = connect(
    mapStateToProps,
    undefined,
)((props: Props) => <GeneralLedgerComp {...props}/>);
